// src/components/lists/OrdersList.js
import React, { Component } from "react";
import { List, Segment,Icon, Card, Table } from "semantic-ui-react";
import OrderItem from "./Items/OrderItem";
import Pagination from "../../utils/Pagination2";
import { connect } from "react-redux";
import { getExamsByOrder } from "../../actions/exams"; // Acción de exámenes

const options = [
  { key: "1", text: "10 por página", value: 10 },
  { key: "2", text: "20 por página", value: 20 },
  { key: "3", text: "50 por página", value: 50 },
  { key: "4", text: "100 por página", value: 100 },
];

class OrdersList extends Component {
  state = {
    allRows:[],
    paginatedItems: [],
    //itemsPerPage: 10,
    itemsPerPage: Number(localStorage.getItem("itemsPerPage")) || 10,
    //currentPage: 1,
    currentPage: Number(localStorage.getItem("currentPage")) || 1,
  };

 componentDidMount() {
  const { orders, examsByOrder } = this.props;
   
  if (orders && orders.length > 0) {
        orders.forEach(order => {
          this.props.getExamsByOrder(order.orderNumber); // Llama a la acción para obtener los exámenes
        });
    }
  //this.updatePageRows();
}

/*componentDidUpdate() {
  const { orders, examsByOrder } = this.props;
   console.log('UPDATE',orders)
  if (orders && orders.length > 0) {
        orders.forEach(order => {
          this.props.getExamsByOrder(order.orderNumber); // Llama a la acción para obtener los exámenes
        });
    }
  //this.updatePageRows();
}*/

componentDidUpdate2(prevProps) {
  const { orders, examsByOrder } = this.props;

  if (orders !== prevProps.orders || examsByOrder !== prevProps.examsByOrder) {
      orders.forEach(order => {
        if (order && order.orderNumber && !examsByOrder[order.orderNumber]) {
        
          this.props.getExamsByOrder(order.orderNumber);
        }
        });
      }
}

componentDidUpdate(prevProps) {
  const { orders, examsByOrder } = this.props;

  if (orders !== prevProps.orders) {
    // Al cambiar las órdenes filtradas, volver a la primera página
    if (this.state.currentPage !== 1) {
      this.setState({ currentPage: 1 });
    }
  }

  if (orders !== prevProps.orders || examsByOrder !== prevProps.examsByOrder) {
    (orders || []).forEach((order) => {
      if (
        order &&
        order.orderNumber &&
        !examsByOrder?.[order.orderNumber]
      ) {
        this.props.getExamsByOrder(order.orderNumber);
      }
    });
  }
}

  onChangePage = (pageItem) => {
    console.log('se nombra muchas veces')
    this.setState({
      currentPage: pageItem
    });
  };

  onItemsPerPageChange = (value) => {

  localStorage.setItem("itemsPerPage", value);
  localStorage.setItem("currentPage",1); 

  this.setState({
    itemsPerPage: value,
    currentPage: 1 // reset al cambiar tamaño
  });
};

  handleOrderClick = (orderNumber) => {
      this.props.getExamsByOrder(orderNumber);
    };

  buildRows2 = () => {
    //const { itemsPerPage, search } = this.state;
    const { orders, examsByOrder } = this.props;
    const rows = [];

    if(!orders) return rows;
  
    orders.forEach(order => {
      const orderData = examsByOrder[order.orderNumber] || {};

      //const exams = order.examsFiltered || examsByOrder[order.orderNumber] || [];
      const exams = orderData.exams || [];
      const isOrderSpecial = orderData.isOrderSpecial || false;

      if(isOrderSpecial){
        rows.push({
          orderHis:order.orderHis,
          orderNumber:order.orderNumber,
          date:order.date,
          exam:null,
          isOrderSpecial:true
        });

        return;
      }

       if (!exams || exams.length === 0) return;

        exams.forEach(exam => {
          rows.push({
            orderHis: order.orderHis,
            orderNumber: order.orderNumber,
            date: order.date,
            exam: exam, 
          })
        })
        
    });
    
    return rows;
  }

  
buildRows1 = () => {
  const { orders, examsByOrder } = this.props;
  const rows = [];

  if (!orders) return rows;

  orders.forEach((order) => {
    const orderData = examsByOrder?.[order.orderNumber] || {};

    // Si la orden viene filtrada desde OrdersSection,
    // usamos únicamente los exámenes coincidentes.
    const exams = Array.isArray(order.examsFiltered)
      ? order.examsFiltered
      : Array.isArray(order.exams)
        ? order.exams
        : orderData.exams || [];

    const isOrderSpecial =
      order.isOrderSpecial ?? orderData.isOrderSpecial ?? false;

    if (isOrderSpecial && exams.length === 0) {
      rows.push({
        orderHis: order.orderHis,
        orderNumber: order.orderNumber,
        date: order.date,
        exam: null,
        isOrderSpecial: true,
      });

      return;
    }

    if (!exams || exams.length === 0) return;

    exams.forEach((exam) => {
      rows.push({
        orderHis: order.orderHis,
        orderNumber: order.orderNumber,
        date: order.date,
        exam,
        isOrderSpecial: false,
      });
    });
  });

  return rows;
};


buildRows = () => {
  const { orders, examsByOrder } = this.props;
  const rows = [];

  if (!orders) return rows;

  orders.forEach((order) => {
    const orderData = examsByOrder?.[order.orderNumber] || {};

    const exams = Array.isArray(order.examsFiltered)
      ? order.examsFiltered
      : Array.isArray(order.exams)
        ? order.exams
        : orderData.exams || [];

    const isOrderSpecial =
      order.isOrderSpecial ?? orderData.isOrderSpecial ?? false;

    // Si no tiene exámenes relacionados, mostrar igualmente la orden.
    if (exams.length === 0) {
      rows.push({
        orderHis: order.orderHis,
        orderNumber: order.orderNumber,
        date: order.date,
        exam: null,
        isOrderSpecial,
      });

      return;
    }

    // Si tiene exámenes, generar una fila por cada uno.
    exams.forEach((exam) => {
      rows.push({
        orderHis: order.orderHis,
        orderNumber: order.orderNumber,
        date: order.date,
        exam,
        isOrderSpecial,
      });
    });
  });

  return rows;
};



 /*buildRows = (ordersArg = null, examsByOrderArg = null) => {
  const { itemsPerPage } = this.state;
  const orders = ordersArg || this.props.orders;
  const examsByOrder = examsByOrderArg || this.props.examsByOrder;
  const rows = [];

  orders.forEach(order => {
    const exams = order.examsFiltered || examsByOrder[order.orderNumber] || [];
    exams.forEach(exam => {
      rows.push({
        orderHis: order.orderHis,
        orderNumber: order.orderNumber,
        date: order.date,
        exam: exam,
      });
    });
  });

  return rows;
};*/


  updatePageRows = (pageRows = null) => {
    
    const allRows = this.buildRows();

    this.setState({
      pageRows:pageRows || allRows.slice(0, this.state.itemsPerPage)
    })
  }

  /*handlePageChange = (newPageRows) => {
    this.setState({ pageRows: newPageRows })
  }*/

  /*getAllRows = () => {
    const { orders, examsByOrder } = this.props;
    const rows = [];

    orders.forEach(order => {
      const exams = order.examsFiltered || examsByOrder[order.orderNumber] || [];
      exams.forEach(exam => {
        rows.push({
          orderHis: order.orderHis,
          orderNumber: order.orderNumber,
          date: order.date,
          exam,
        });
      });
    });
    console.log('ROWS', rows)
    return rows;
  };*/

   /*getPageRows = () => {
    const { itemsPerPage } = this.state;
    const allRows = this.getAllRows();
   
    const start = (1 - 1) * itemsPerPage;
  
    return allRows.slice(start, start + itemsPerPage);
  };*/

  render() {
    const { selectedPatient, selectedPatientID } = this.props;
    const { itemsPerPage , currentPage} = this.state;

    const allRows = this.buildRows()
   
    const start = (currentPage - 1) * itemsPerPage;
    const pageRows = allRows.slice(start, start + itemsPerPage);

    return (
      <Segment>
        <Table compact="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={2}>Orden HIS</Table.HeaderCell>
            <Table.HeaderCell width={1}>Orden LIS</Table.HeaderCell>
            <Table.HeaderCell width={11}>Examen </Table.HeaderCell>
            <Table.HeaderCell width={2}>Fecha</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {pageRows.map((row, idx) => (
           <OrderItem
              order={row}
              key={`${row.orderNumber}-${idx}`}
              selectedPatientID={selectedPatientID}
              selectedPatient={selectedPatient}
              showPatientOrderResults={this.props.showPatientOrderResults}
              showPatientOrderResultsOne={this.props.showPatientOrderResultsOne}
              handleOrderClick={this.handleOrderClick}
              exams={row.exam}
              isOrderSpecial={row.isOrderSpecial}
        />
          ))}
          <Table.Row>
           
          </Table.Row>
        </Table.Body>
      </Table>
      {pageRows.length > 0 && (
       <Pagination
          totalItems={allRows.length}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={this.onChangePage}
          onItemsPerPageChange={this.onItemsPerPageChange}
          options={options}
        />
        )}
      </Segment>
      
    )
  }
  }

const mapStateToProps = (state) => ({
  //orders: state.allPatientOrders.orders,
  patient_id: state.selectedPatient.patient_id,
  patient_fullname: state.selectedPatient.fullname,
  examsByOrder: state.examsByOrder.examsByOrder,  // Corrección aquí  // Assuming examsByOrder is stored in the Redux state
});

export default connect(mapStateToProps,{ getExamsByOrder })(OrdersList);
